import { render, staticRenderFns } from "./ApplyFaq.vue?vue&type=template&id=6215f5db&"
import script from "./ApplyFaq.vue?vue&type=script&lang=js&"
export * from "./ApplyFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports